/* ============================================================================
   We Feed You — resync the header/side/main cart counts after a Custlo add
   Install as: assets/wfy-custlo-cart-sync.js
   Load in layout/theme.liquid before </body>:
     <script src="{{ 'wfy-custlo-cart-sync.js' | asset_url }}" defer></script>

   WHY: Custlo's "My Favourites" (and reorder) add posts to /cart/add.js directly
   and doesn't call the theme's window.ajaxCart.load(...), so #cart-count and the
   side/main-cart item counts don't update (the cart & price are correct — only the
   count elements are stale). This intercepts /cart/add(.js) on fetch AND XHR and
   triggers the theme's own re-render (which updates the counts). Coalesced by a
   short debounce; scoped to the Custlo dashboard only.

   BEHAVIOUR:
     • Desktop (>=768px): open the side cart (drawer), as before.
     • Mobile  (<768px):  DON'T open the drawer — just refresh the counts and show
       the theme's own toast ("N x Meal — added to cart"). handleCartPanel() calls
       updateCartCount() unconditionally, so the counts update even without opening.
       The toast (#add-to-cart-toast, in theme.liquid) is CSS-gated to mobile only.
   ============================================================================ */
(function () {
  "use strict";

  // <768px == exactly when the theme shows #add-to-cart-toast (its CSS hides it at min-width:768px)
  function isMobile() { return !window.matchMedia("(min-width: 768px)").matches; }

  var added = [];   // {title, qty} captured from the /cart/add.js response during a burst

  function record(text) {
    try {
      var data = JSON.parse(text);
      var items = (data && data.items) ? data.items : (data ? [data] : []);
      items.forEach(function (it) {
        if (!it) return;
        added.push({ title: it.product_title || it.title || "Item", qty: it.quantity || 1 });
      });
    } catch (e) { /* leave `added` as-is; toast falls back to a generic message */ }
  }

  function toastMessage() {
    if (added.length === 1) {
      return (added[0].qty || 1) + " × " + added[0].title + "<br>added to cart";
    }
    if (added.length > 1) {
      var total = added.reduce(function (n, it) { return n + (it.qty || 1); }, 0);
      return total + " items<br>added to cart";
    }
    return "Added to cart";
  }

  function refresh() {
    // only act on the Custlo dashboard (where My Favourites lives) — never interfere with the theme's own add flow
    if (!document.querySelector('[class*="custlo-t1"]')) { added = []; return; }

    var mobile = isMobile();

    if (window.ajaxCart && typeof window.ajaxCart.load === "function") {
      // open the drawer on desktop only; on mobile refresh counts without opening
      try { window.ajaxCart.load(null, mobile ? false : true, false, true); } catch (e) {}
    } else {
      // fallback: let any theme listeners know the cart changed
      document.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: true }));
    }

    if (mobile && typeof window.showAddToCartToast === "function") {
      try { window.showAddToCartToast(toastMessage()); } catch (e) {}
    }

    added = [];
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(refresh, 250); }   // coalesce bursts
  function isAdd(url) { return typeof url === "string" && /\/cart\/add(\.js)?(\?|$)/.test(url); }

  // fetch()
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === "string") ? input : (input && input.url);
      var p = of.apply(this, arguments);
      if (isAdd(url)) {
        p.then(function (r) {
          try { r.clone().text().then(record); } catch (e) {}
          schedule();
          return r;
        }).catch(function () {});
      }
      return p;
    };
  }

  // XMLHttpRequest
  var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__wfyAdd = isAdd(u); return oOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__wfyAdd) {
      this.addEventListener("load", function () {
        try { if (this.status >= 200 && this.status < 300) record(this.responseText); } catch (e) {}
        schedule();
      });
    }
    return oSend.apply(this, arguments);
  };
})();
